import React, { Suspense, Component } from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/Routes';
// import firebase from './utils/firebase';
import history from './routes/History';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as Action from './store/Checkout/actions';
import * as ActivationAction from './store/Activation/actions';
import * as BillingAction from './store/Billing/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { domainName, domainMap, configPayload } from './config';
// import { setTimeout } from 'timers';
type initialProps = { 
    CheckoutActions: any; 
    CheckoutState: any; 
    ActivationActions: any; 
    ActivationState: any;
    BillingActions: any;
    BillingState: any;
};
type initialState = { user: any, configVals: any };

export class App extends Component<initialProps, initialState> {
    state: initialState = { user: null, configVals: null };
    async componentDidMount() {
        let url: string = domainName === domainMap.T2 ? '/favicon.png' : '/favicon.png';
        let element: any = document.getElementById('favicon');
        element.href = url;
        if(process.env.REACT_APP_SERVER_NAME?.includes("prod")) {
            console.log = function () {};
        }
        const ssoToken: any = localStorage.getItem('astoundAccessToken');
        if(ssoToken) {
            this.props.BillingActions.config(configPayload)
        }

        // let currentuser: any =
        //     domainName === domainMap.T2
        //         ? localStorage.getItem('earthlinkCurrentUser')
        //         : localStorage.getItem('currentuser');
        // currentuser = JSON.parse(currentuser);
        // if (currentuser && currentuser.email) {
        //     await this.props.CheckoutActions.GetCustomer({
        //         username: encodeURIComponent(currentuser && currentuser.email),
        //     });
        // }

        // if (
        //     domainName === domainMap.T1 &&
        //     !(
        //         (currentuser &&
        //             currentuser &&
        //             currentuser.uid &&
        //             currentuser.stsTokenManager &&
        //             currentuser.stsTokenManager.accessToken &&
        //             !currentuser.isAnonymous) ||
        //         window.location.pathname === '/login' ||
        //         window.location.pathname === '/signup' ||
        //         window.location.pathname === '/home' ||
        //         window.location.pathname.includes('/recover') ||
        //         window.location.pathname === '/cell-phone-plans' ||
        //         window.location.pathname === '/plans/' ||
        //         window.location.pathname === '/international_services' ||
        //         window.location.pathname === '/homeDummy' ||
        //         window.location.pathname === '/bestfit' ||
        //         window.location.pathname === '/imei-compatibility-check' ||
        //         window.location.pathname === '/giveback' ||
        //         window.location.pathname === '/checkout' ||
        //         window.location.pathname === '/terms' ||
        //         window.location.pathname === '/privacy' ||
        //         window.location.pathname === '/contact-us' ||
        //         window.location.pathname === '/bill-calculator' ||
        //         window.location.pathname === '/about-us' ||
        //         window.location.pathname.includes('/discover') ||
        //         window.location.pathname.includes('/reviews') ||
        //         window.location.pathname === '/coverage-check' ||
        //         window.location.pathname === '/coverage-map' ||
        //         // window.location.pathname === '/track-order' ||
        //         // window.location.pathname === '/feedback' ||
        //         // window.location.pathname === '/presim' ||
        //         // window.location.pathname === '/postsim' ||
        //         // window.location.pathname === '/siminhand' ||
        //         // window.location.pathname === '/post-activation-home' ||
        //         // window.location.pathname === '/billing' ||
        //         window.location.pathname === '/help' ||
        //         // window.location.pathname === '/account' ||
        //         // window.location.pathname === '/services' ||
        //         // window.location.pathname === '/loader' ||
        //         window.location.pathname.includes('/lp01-allplans') ||
        //         window.location.pathname.includes('/best-fit-15gb-plan') ||
        //         window.location.pathname.includes('/best-fit-10gb-plan') ||
        //         window.location.pathname.includes('/best-fit-5gb-plan') ||
        //         window.location.pathname.includes('/best-fit-2gb-plan') ||
        //         window.location.pathname.includes('/unlimited-25gb+-plan') ||
        //         window.location.pathname.includes('/lp01-crossout-plan') ||
        //         window.location.pathname.includes('lp01-giveback') ||
        //         window.location.pathname.includes('/lp01-bestfit') ||
        //         window.location.pathname === '/'
        //     )
        // ) {
        //     history.push('/login');
        // }
        // if (
        //     domainName === domainMap.T2 &&
        //     !(
        //         (currentuser &&
        //             currentuser &&
        //             currentuser.uid &&
        //             currentuser.stsTokenManager &&
        //             currentuser.stsTokenManager.accessToken &&
        //             !currentuser.isAnonymous) ||
        //         // window.location.pathname === '/activation' ||
        //         // window.location.pathname === '/device-setup' ||
        //         // window.location.pathname === '/home' ||
        //         // window.location.pathname === '/device' ||
        //         // window.location.pathname === '/help' ||
        //         // window.location.pathname === '/account' ||
        //         // window.location.pathname === '/track-order' ||
        //         // window.location.pathname === '/billing' ||
        //         // window.location.pathname === '/tracking-history' ||
        //         window.location.pathname === '/login' ||
        //         window.location.pathname.includes('/earthlink-recover') ||
        //         window.location.pathname === '/'
        //     )
        // ) {
        //     history.push('/login');
        // }
    }
    componentDidUpdate(prevProps: initialProps) {
        const prev = prevProps && prevProps.CheckoutState;
        const cur = this.props && this.props.CheckoutState;
        const prevAct = prevProps && prevProps.ActivationState;
        const curAct = this.props && this.props.ActivationState;
        if (
            prev.getCustomer !== cur.getCustomer &&
            cur.getCustomer &&
            cur.getCustomer.status === 'SUCCESS' &&
            cur.getCustomer.data
        ) {
            this.setState({ user: cur.getCustomer.data });
            // if (domainName === domainMap.T1) {
            //     if (
            //         !(curAct && curAct.activationStatus && curAct.activationStatus.data) &&
            //         cur.getCustomer.data.activationStatus > 0 &&
            //         (window.location.pathname.includes('/my-account') ||
            //             window.location.pathname.includes('/activation'))
            //     ) {
            //         this.props.ActivationActions.activationStatus({
            //             customerId: cur.getCustomer.data && cur.getCustomer.data.id,
            //         });
            //     }
            // }
        }
        if (
            domainName === domainMap.T1 &&
            prevAct.errorActivationStatus !== curAct.errorActivationStatus &&
            curAct.errorActivationStatus &&
            curAct.errorActivationStatus.status === 'FAILURE'
        ) {
            setTimeout(() => {
                this.props.ActivationActions.activationStatus({
                    customerId: cur.getCustomer.data && cur.getCustomer.data.id,
                });
            }, 30000);
        }
        if (domainName === domainMap.T2 && prev.errorGetCustomer !== cur.errorGetCustomer && cur.errorGetCustomer) {
            console.log(cur.errorGetCustomer);
            history.push({
                pathname: '/login',
                state: {
                    isErrorGetCustomer: true,
                    error: cur.errorGetCustomer,
                },
            });
        }
    }

    // authListener = () => {
    //     firebase.auth().onAuthStateChanged(user => {
    //         if (user) {
    //             user.getIdToken()
    //                 .then(function(idToken) {
    //                     localStorage.setItem('accessToken', idToken);
    //                 })
    //                 .catch(function(error) {
    //                     console.log(error);
    //                 });
    //         } else {
    //             this.setState({
    //                 user: '',
    //             });
    //         }
    //     });
    // };
    render() {
        return (
            <Suspense
                fallback={
                    <div
                        style={{
                            marginTop: '20px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress />
                    </div>
                }
            >
                <div className="AppMainPage">
                    <ReactNotification />
                    <Router>
                        <Routes />
                    </Router>
                </div>
            </Suspense>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        CheckoutActions: bindActionCreators(Action, dispatch),
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        BillingActions: bindActionCreators(BillingAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    CheckoutState: state.checkout,
    ActivationState: state.activation,
    BillingState: state.billing,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
